import { makeStyles } from '@material-ui/styles';
import { Theme } from '@bizzabo/design-system';

const EmptyBanUsersList = () => {
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <div className={classes.title}>Blocked Attendees</div>
            <div className={classes.description}>
                The attendees you block will appear here. You can also come here to unblock them.
            </div>
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            flexDirection: 'column',
            padding: '0 75px',
            color: theme.palette.greys['500'],
        },
        title: {
            fontWeight: 600,
            fontSize: 22,
            marginBottom: 14,
        },
        description: {
            fontSize: 12,
            textAlign: 'center',
            textTransform: 'uppercase',
        },
    }),
    {
        classNamePrefix: 'EmptyBanUsersList',
    }
);

export default EmptyBanUsersList;
